export class ListAccessibleAccountsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "accounts",
            "baseName": "accounts",
            "type": "Array<AccessibleOrganizationAccount>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAccessibleAccountsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
